<template lang="pug">
div
  router-view(v-show="initializationFinished")
  global-loading
  splash-screen
  sound-manager
</template>

<script>
import $ from 'jquery'
window.jQuery = window.$ = $

import { mapGetters } from 'vuex'
import SplashScreen from '@/components/SplashScreen'
import GlobalLoading from '@/components/GlobalLoading'
import SoundManager from '@/components/SoundManager/SoundManager'
import Noty from '@/components/shared/Notify'

// import fr from '@/locales/fr'
// import en from '@/locales/en'

export default {
  name: 'app',
  components: {
    SplashScreen,
    SoundManager,
    GlobalLoading
  },
  data() {
    return {
      currentRev: ''
    }
  },
  mounted() {
    // function compare(l1, l2, path) {
    //   let keys1 = Object.keys(l1)
    //   let keys2 = Object.keys(l2)
    //   for (let i = 0; i < keys1.length; i++) {
    //     if (!keys2.includes(keys1[i])) {
    //       console.log('Il manque ' + path + keys1[i] + ' dans le fichier 2')
    //     } else if (l1[keys1[i]] instanceof Object) {
    //       compare(l1[keys1[i]], l2[keys1[i]], path + keys1[i] + '.')
    //     }
    //   }
    //   for (let i = 0; i < keys2.length; i++) {
    //     if (!keys1.includes(keys2[i])) {
    //       console.log('Il manque ' + path + keys2[i] + ' dans le fichier 1')
    //     }
    //   }
    // }
    // compare(fr, en, '')
    this.$router.beforeEach((to, from, next) => {
      const lang = to.query.lang
      if (lang) {
        this.$cookie.set('lg', lang)
        this.$i18n.changeLocale(lang, this)
        this.$store.dispatch('user/setLanguage', lang)
      }
      next()
    })
    fetch('/.rev')
      .then(response => {
        if (response.status === 200) {
          response
            .text()
            .then(text => {
              this.currentRev = text
              let interval = setInterval(() => {
                fetch('/.rev')
                  .then(response => {
                    if (response.status === 200) {
                      response
                        .text()
                        .then(text => {
                          if (this.currentRev !== text) {
                            clearInterval(interval)
                            let notification = Noty.info(
                              this._i18n.t('newVersion')
                            )
                            notification.on('onClose', () => {
                              location.reload(true)
                            })
                          }
                        })
                        .catch(() => {})
                    }
                  })
                  .catch(() => {})
              }, 5 * 60 * 1000)
            })
            .catch(() => {})
        }
      })
      .catch(() => {})
    function gtag() {
      window.dataLayer.push(arguments)
    }
    if (process.env.NODE_ENV === 'production') {
      var googleSrc = document.createElement('script')
      googleSrc.setAttribute(
        'src',
        'https://www.googletagmanager.com/gtag/js?id=UA-38351047-1'
      )
      googleSrc.setAttribute('async', '')
      document.head.appendChild(googleSrc)
      window.dataLayer = window.dataLayer || []
      gtag('js', new Date())
      gtag('config', 'UA-38351047-1')
      window.gtag = gtag
    }
  },
  computed: {
    ...mapGetters('user', ['isInitialized', 'isConnected']),
    ...mapGetters('groops', ['groopsAreLoaded']),
    initializationFinished() {
      return this.isInitialized && (!this.isConnected || this.groopsAreLoaded)
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?0064717f